<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<div class="boxnote">
</div>
<div class="boxnote">
<h1 class="book-title"><a id="page_3"></a>SECRET<br/><span class="smallcaps">OF THE</span><br/>DRAGON</h1>
<p class="author">MARGARET WEIS<br/><span class="small">AND</span><br/>TRACY HICKMAN</p>
</div>
<div class="boxnote">
</div>
<p class="linespace"> </p>
<p class="editor"><img alt="Images" src="images/pub.jpg"/><br/>A TOM DOHERTY ASSOCIATES BOOK<br/>NEW YORK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?030bbbe6